import { AjaxGenerateToken, AsyncAjaxPost } from "../utils/AsyncAjaxService"

const AmplitudeAddLog = async (userID, businessID, businessName,step, grp, appConfirmUnqiueId) => {
  var logobject = {};
  logobject.PageURL = window.location.href;
  logobject.Step = step;
  logobject.UserAgent = (navigator.userAgent).toLowerCase();
  logobject.UserIDEnc = userID;
  logobject.BusinessIDEnc = businessID;
  logobject.BusinessName = businessName;

  logobject.ServiceName = appConfirmUnqiueId;

  const VagaroAPIEnum = {
    updateToken: "Token/generatetoken"
  };

  await AjaxGenerateToken(
    VagaroAPIEnum.updateToken,
    null,
    function onSuccess(data) {
      logobject.accessToken = data?.data?.access_token;
      AddLogInAmplitude(logobject, grp);
    }, function onFail(data) {
    }, grp)

};
const AddLogInAmplitude = async (logobject, grp) => {
  let data;
  data = {
    PageURL: logobject.PageURL,
    Step: logobject.Step,
    UserAgent: logobject.UserAgent,
    UserIDEnc: logobject.UserIDEnc,
    BusinessIDEnc: logobject.BusinessIDEnc,
    ServiceName: logobject.ServiceName
  };
  const VagaroAPIEnum = {
    AddLogInAmplitude: "amplitude/addloginamplitude",
  };

  await AsyncAjaxPost(
    VagaroAPIEnum.AddLogInAmplitude,
    data,
    logobject.accessToken,
    function onSuccess(data) {
      try {
        if (data != null && data.data != null && data.data.data != null) {
        }
      } catch (error) {
        console.log("error");
      }
    },
    function OnError() {
      console.log("error");
    },
    "", "", grp
  );
}
export { AmplitudeAddLog };